import {
    ascend,
    filter,
    fromPairs,
    map,
    omit,
    pipe,
    prop,
    slice,
    sortWith,
    values,
    when
} from 'ramda';

export const truncateExtraDecimals = (num) => {
    const idx = num.toString().indexOf('.');
    return idx >= 0
        ? Number(num.toString().slice(0, idx + 3))
        : num;
};

export const parseCustomAttributes = ({ customAttributes = [], ...rest }) => ({
    ...rest,
    ...pipe(
        map(({ name, value }) => [name, value]),
        fromPairs
    )(customAttributes)
});

export const prepareCompetitorsTable = (details) => {
    let { competitorsTable } = details;

    if (!competitorsTable) {
        return details;
    }

    const { rank: myRank } = details;
    let prevRank = 0;

    competitorsTable = competitorsTable.map((competitor) => {
        const newCompetitor = { ...competitor };
        const { rank, name, nickName, score } = competitor;

        if (myRank === rank) {
            newCompetitor.isMe = true;
        }

        if (rank - prevRank > 1) {
            newCompetitor.addDivider = true;
        }

        prevRank = rank;

        newCompetitor.score = truncateExtraDecimals(score);

        return {
            ...newCompetitor,
            name: nickName || name
        };
    });

    return {
        ...details,
        competitorsTable
    };
};

export const getName = ({ name, displayName, ...rest }) => ({
    ...rest,
    name: displayName || name
});

export const prepareTopPrizes = when(
    ({ prizes = [] }) => prizes.length > 0,
    ({ prizes, ...rest }) => ({
        ...rest,
        prizes,
        topPrizes: pipe(
            filter(({ iconUrl }) => iconUrl),
            sortWith([ascend(prop('hiRank'))]),
            slice(0, 3)
        )(prizes)
    })
);

// may be changed in future
export const handleLeaving = when(
    ({ joined }) => !joined,
    pipe(
        omit(['rank', 'score']),
        when(
            ({ eventCountLimit, eventCount }) => eventCountLimit != null && eventCount > 0,
            ({ eventCountLimit, ...rest }) => ({
                ...rest,
                eventCountLimit,
                eventCount: 0,
                remainingEventCount: eventCountLimit
            })
        )
    )
);

export const prepareLeaderBoardDetails = pipe(
    getName,
    handleLeaving,
    parseCustomAttributes,
    prepareCompetitorsTable,
    prepareTopPrizes
);

export const getLeaderBoardList = when(
    list => !Array.isArray(list),
    pipe(
        values,
        map(prop('leaderboardDetails')),
        filter(Boolean)
    )
);

export const prepareLeaderBoardList = pipe(
    getLeaderBoardList,
    map(omit(['competitorsTable'])),
    map(prepareLeaderBoardDetails)
);
